import { State } from '../../../store/state';

export const openedSelector = (state: State) => state.global.opened;
export const foldedSelector = (state: State) => state.global.folded;
export const mobileOpenedSelector = (state: State) => state.global.mobileOpened;
export const dialogSelector = (state: State) => state.global.dialog;
export const snackbarOpenSelector = (state: State) => state.global.snackbarOpen;
export const snackbarMessageSelector = (state: State) => state.global.snackbarMessage;
export const snackbarOptionsSelector = (state: State) => state.global.snackbarOptions;